/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEveVideoLinksData } from './eve-video-links.data';
import { IEveVideoLinksProps } from './eve-video-links.props.autogenerated';

export interface IEveVideoLink {
    imageUrl: string;
    videoUrl: string;
    linkUrl: string;
    linkText: string;
}

export interface IEveVideoLinksViewProps extends IEveVideoLinksProps<IEveVideoLinksData> {
    renderLinks: React.ReactNode;
}

/**
 *
 * EveVideoLinks component
 * @extends {React.PureComponent<IEveVideoLinksProps<IEveVideoLinksData>>}
 */
class EveVideoLinks extends React.PureComponent<IEveVideoLinksProps<IEveVideoLinksData>> {
    private _renderLink = (links: IEveVideoLink[] | null): React.ReactNode => {
        if (links) {
            return links.map(l => {
                return (
                    <a key={l.linkText} className='image-video-container' href={l.linkUrl}>
                        <video className='video' loop muted src={l.videoUrl}></video>
                        <img className='image' src={l.imageUrl} />
                        <span className='text'>{l.linkText}</span>
                    </a>
                );
            });
        }
        return <></>;
    };
    public render(): JSX.Element | null {
        const linksJson = this.props.config.linksJson;
        const viewProps = {
            ...this.props,
            renderLinks: this._renderLink(linksJson ? JSON.parse(linksJson) : null)
        };
        return this.props.renderView(viewProps);
    }
}

export default EveVideoLinks;
